const TOKEN_KEY = 'auth_token';
const USER_KEY = 'auth_user';

export function getAuthToken(): string | null {
  if (typeof window === 'undefined') return null;
  return window.localStorage.getItem(TOKEN_KEY);
}

export function setAuthToken(token: string | null): void {
  if (typeof window === 'undefined') return;
  if (token) {
    window.localStorage.setItem(TOKEN_KEY, token);
  } else {
    window.localStorage.removeItem(TOKEN_KEY);
  }
}

export function setAuthUser(user: unknown | null): void {
  if (typeof window === 'undefined') return;
  if (user) {
    window.localStorage.setItem(USER_KEY, JSON.stringify(user));
  } else {
    window.localStorage.removeItem(USER_KEY);
  }
}

export function getAuthUser<T = unknown>(): T | null {
  if (typeof window === 'undefined') return null;
  const raw = window.localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function isAuthenticated(): boolean {
  return !!getAuthToken();
}

export function clearAuth(): void {
  setAuthToken(null);
  setAuthUser(null);
}

export function redirectToLogin(from?: string): void {
  if (typeof window === 'undefined') return;
  const current =
    from ||
    `${window.location.pathname}${window.location.search}${window.location.hash}`;
  const target = new URL(`${window.location.origin}/login`);
  if (current && current !== '/login') {
    target.searchParams.set('from', current);
  }
  window.location.href = target.toString();
}

export function handleUnauthorized(): void {
  clearAuth();
  redirectToLogin();
}
